import QuizToWin from './QuizToWin.container';

export default QuizToWin;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/quizToWin/index.js